// Vendor imports
const _ = require('lodash')
// Client lib imports
const { send: ajax } = require('client/lib/request')
const airbrake = require('client/lib/airbrake')
// Common Client V2 imports
const articleProfileModalActions = require('client-v2/common/containers/article-profile/state/modal-actions')
const {
  isArticleModel,
  getCachedReportedUrlIds
} = require('client-v2/common/models/article/utils')
// Sibling imports
const { defaultFeedSelectors } = require('./selectors')

let lastFeedInstanceId = 0

module.exports = {
  createFeedActions,
  defaultFeedActions: createFeedActions(defaultFeedSelectors)
}

function createFeedActions(feedSelectors) {
  // Disambiguate against other feed instances
  const feedInstanceId = ++lastFeedInstanceId

  // Instance action types

  const MORE_LOADING = `FEED_${feedInstanceId}_MORE_LOADING`
  const MORE_LOADED = `FEED_${feedInstanceId}_MORE_LOADED`

  // Instance action dispatchers

  function loadMore() {
    return loadMoreThunk
  }

  function showArticleProfileModal(options = {}) {
    const initialUrlId = options.urlId || _.get(options, ['article', 'url_id'])
    return function (dispatch, getState) {
      const state = getState()
      const articleItems = feedSelectors.getItems(state).filter(isArticleModel)
      const initialIndex = initialUrlId
      ? articleItems.findIndex(obj => obj.id === initialUrlId)
      : articleItems.size ? 0 : -1
      // Don't show the ArticleProfileModal if there is no initial item to show
      if (initialIndex === -1) {
        return
      }
      dispatch(articleProfileModalActions.show({
        initialIndex,
        items: articleItems,
        meta: feedSelectors.getMeta(state),
        nextPageCallback
      }))
      async function nextPageCallback() {
        const { items, meta } = await loadMoreThunk(dispatch, getState)
        return { items: items.filter(isArticleModel), meta }
      }
    }
  }

  // Instance action creators

  function loading() {
    return {
      type: MORE_LOADING
    }
  }

  function loaded({ items, meta }) {
    return {
      type: MORE_LOADED,
      payload: { items, meta }
    }
  }

  // Instance action helpers

  async function loadMoreThunk(dispatch, getState) {
    const state = getState()
    if (!feedSelectors.getIsNextPageAvailable(state)) {
      throw new Error('No more content available')
    }
    dispatch(loading())
    try {
      const response = normalizeMoreResponse(await ajax({
        url: feedSelectors.getNextPageUrl(state),
        method: 'get'
      }))
      dispatch(loaded(response))
      return response
    } catch (err) {
      airbrake.notify(err)
      throw err
    }
  }

  // Instance exports

  return {
    MORE_LOADING,
    MORE_LOADED,
    loadMore,
    showArticleProfileModal
  }
}

// Instance-agnostic action helpers

function normalizeMoreResponse(response) {
  if (!response) {
    return { items: [], meta: { nextUrl: null } }
  }
  let { meta } = response
  // Handle the inconsistent shape of the user API stream
  // See app/controllers/api/user-controller methods
  let items = (
    response.items ||
    response.mixes ||
    response.followingMixes ||
    response.friends ||
    response.followers ||
    []
  )
  // Reject reported URLs that have been locally cached
  const reportedUrlIds = getCachedReportedUrlIds()
  if (reportedUrlIds.length) {
    items = _.reject(items, item => (
      isArticleModel(item) &&
      reportedUrlIds.includes(item['url_id'])
    ))
  }
  // Handle the blindly-optimistic server-side pagination logic
  if (!items.length) {
    meta = { nextUrl: null }
  }
  return { items, meta }
}
